
import { BsFillPersonFill } from "react-icons/bs";
import { GiPalmTree } from 'react-icons/gi'
import { FaFileInvoiceDollar, FaBookmark, FaTools,  FaFileAlt} from 'react-icons/fa';

const _navigation = [ 
        { 
            'section': 'PERSONAL',
            'rol_admin': false,
            'menu': [
                {   
                    'nombre': 'Mi Perfil',
                    'icon': <BsFillPersonFill className="svg-icon-aside"/>,
                    'link': '/profile',
                    'subMenu': []
                },
                {   
                    'nombre': 'Liquidaciones de Sueldo',
                    'icon': <FaFileInvoiceDollar className="svg-icon-aside"/>,
                    'link': '/salarySettlement',
                    'subMenu': []
                },
                {   
                    'nombre': ' Cert. de Antigüedad',
                    'icon': <FaFileAlt className="svg-icon-aside"/>,
                    'link': '/certificate/seniority',
                    'subMenu': []
                }
            ]
        },
        { 
            'section': 'Adicional',
            'rol_admin': false,
            'menu': [
                {   
                    'nombre': 'Beneficios',
                    'icon': <FaBookmark className="svg-icon-aside"/>,
                    'link': '/benefits',
                    'subMenu': []
                },
                {   
                    'nombre': 'Vacaciones (en mantención)',
                    'icon': <GiPalmTree className="svg-icon-aside"/>,
                    'link': '/vacations',
                    'subMenu': []
                }
            ]
        },
        { 
            'section': 'Admin',
            'rol_admin': true,
            'menu': [
                {   
                    'nombre': 'Mantenedores',
                    'icon': <FaTools className="svg-icon-aside"/>,
                    'link': '/admin',
                    'subMenu': [
                        {
                            'nombre': 'Usuarios',
                            'link': '/admin/user',
                        },
                        {
                            'nombre': 'Beneficios',
                            'link': '/admin/benefit',
                        }                      
                    ]
                }
            ]
        }
   
]

export default _navigation